// @ts-nocheck
import { Tooltip, TooltipProps } from 'antd'

export interface KBTooltipProps extends TooltipProps {}

export function KBTooltip(props: TooltipProps) {
  return <Tooltip {...props}></Tooltip>
}
